/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-alert */
import React, { Component } from 'react'
import firebase from 'firebase/app'
import ImageCompressor from 'image-compressor.js'

import { Form, Image, Dimmer, Loader } from 'semantic-ui-react'

export default class ImagePicker extends Component {
  state = {
    compressing: false,
    uploading: false,
    uploadingThumb: false,
  }

  onChange = e => {
    const { compress, uploadOriginal = true } = this.props
    const file = e.target.files[0]

    if (!file) return

    if (uploadOriginal) {
      this.setState({ uploading: true })
      this.upload(file)
    }

    if (compress) {
      this.setState({ compressing: true })
      this.compress(file)
    }

  }

  compress = async file => {
    try {
      const imageCompressor = new ImageCompressor()
      const result = await imageCompressor.compress(file, { quality: 0.6, width: 200 })

      this.setState({ compressing: false, uploadingThumb: true })
      this.upload(result, { isCompressedFile: true })
    } catch (e) {
      alert("There is problem while while compressing file. Please try again.")
    }
  }

  upload = async (file, options = {}) => {
    try {
      const { compressFileName, uploadPath, label, fileName, } = this.props
      const { isCompressedFile } = options

      const name = isCompressedFile
        ? compressFileName || 'thumb'
        : fileName || label

      const uploadRef = firebase.storage().ref().child(`images/${uploadPath}/${name}`)
      const snapshot = await uploadRef.put(file)

      this.uploadSuccess(snapshot, { isCompressedFile, name, file })
    } catch (e) {
      alert("There is problem while uploading file. Please try again.")
    }
  }

  uploadSuccess = async (snapshot, { isCompressedFile, name, file }) => {
    const { onCompressCompleted, onChange, afterUpload = undefined } = this.props
    const downloadURL = await snapshot.ref.getDownloadURL()

    if(afterUpload) {
      await afterUpload(file, name, downloadURL)
    }

    if (isCompressedFile) {
      onCompressCompleted(downloadURL)
      this.setState({ uploadingThumb: false })
    } else {
      onChange(downloadURL)
      this.setState({ uploading: false })
    }
  }

  render() {
    const { url, label } = this.props
    const { compressing, uploading, uploadingThumb } = this.state

    const imageUrl = url || require('../../assets/images/placeholder.png')
    const loading = compressing || uploading || uploadingThumb

    return (
      <Form.Field>
        {label && <label>{label}</label>}
        <input
          hidden
          name="image"
          type="file"
          accept="image/*"
          onChange={ (e) => this.onChange(e) }
          ref={input => { this.imageInput = input }}
        />
        <Image
          src={imageUrl}
          className='image-previewer'
          onClick={ () => this.imageInput.click() }
          dimmer={<Dimmer active={loading}><Loader/></Dimmer>}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/imagePicker.js